import { UseMutationOptions, useMutation } from 'react-query';
import { mutateMatchStatus } from './matchStatus';
import { TMatchStatus } from './matchStatus.types';

export const useMutationMatchStatus = (
  options?: UseMutationOptions<unknown, unknown, TMatchStatus>
) => useMutation((data) => mutateMatchStatus(data), options);
